import type { User } from '@auth0/auth0-react';
import { userHelpers } from './userHelpers';

export function createLaunchDarklyContext(user: User | undefined | null) {
  return {
    kind: 'user',
    key: user?.sub || 'anonymous',
    anonymous: !user,
    rmAliasEmail: userHelpers.hasRmAliasEmail(user),
    tectonic: userHelpers.getTectonicDomain(user),
    subscription: userHelpers.getSubscription(user),
    organization: userHelpers.getOrganizationId(user),
    beta: userHelpers.hasBetaAccess(user),
    internal: userHelpers.isRemarkableUser(user),
    sessionOrgId: userHelpers.getLoggedInOrganizationId(user),
  };
}
